import { useLocation } from "react-router-dom";
import React, { useEffect, useRef, useState } from "react";
import useEmblaCarousel from "embla-carousel-react";

import { text } from "../text";
import { hooks } from "../hooks";
import { utils } from "../utils";
import { theme } from "../constants";
import { components } from "../components";
import useApi from "../customHook/useApi";
import { apibaseurl, verifyOtp } from "../environment";
import { callService } from "../customHook/callService";
import axios, { AxiosError } from "axios";

export interface FullProfile {
  lead_profile_id: string;
  full_name: string | null;
  email: string | null;
  phone_number: string | null;
  gender: string | null;
  dob: string | null;
  pref_budget_min_range: string | null;
  pref_budget_max_range: string | null;
  pref_city_name: string | null;
  pref_city_id: string | null;
  pref_locality_name: string | null;
  pref_locality_id: string | null;
}

export interface VerifyOtpResponse {
  success: boolean;
  statusCode: number;
  phoneNumber: string;
  accessToken: string;
  lead_profile_id: string;
  // price: string;
  message: string;
  full_profile?: FullProfile;
}
export interface ApiErrorResponse {
  success: false;
  statusCode: number;
  message: string;
}

export const Onboarding4: React.FC = () => {
  const navigate = hooks.useNavigate();
  const location = useLocation();
  // const { phonOtp } = location.state || {};
  const { pathname } = useLocation();

  const [otp, setOtp] = useState(["", "", "", ""]);
  const [expectedOtp, setExpectedOtp] = useState(""); // Store the OTP from state
  const inputRefs = useRef<HTMLInputElement[]>([]);
  const [error, setError] = useState("");

  const [confirmModal, setConfirmModal] = useState(false);

  const [varifyOtpLoading, setVarifyOtpLoading] = useState(false);

  useEffect(() => {
    const otpneww = location?.state?.otp?.split?.("");
    // setOtp(otpneww);

    // console.log(
    //   location?.state?.otp,
    //   location?.state?.phoneNumber,
    //   "from navigation"
    // );
  }, []);

  const handleChange = (value: string, index: number) => {
    if (!/^\d*$/.test(value)) return; // allow only numbers

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < 3) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (
    e: React.KeyboardEvent<HTMLInputElement>,
    index: number,
  ) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };

  const buttons = [
    {
      title: "Verify",
      path: "/onbording5",
    },
  ];

  const {
    data: verifyOtpResponse,
    loading: verifyLoading,
    callApi: verifyOtpApi,
  } = useApi<VerifyOtpResponse>(verifyOtp, {
    method: "POST",
    autoCall: false,
    dependencies: [],
  });

  // useEffect(() => {
  //     console.log(verifyOtpResponse?.phoneNumber, "verifyOtpResponse vikas");
  //     const city = verifyOtpResponse?.full_profile?.pref_city_name;
  //     // localStorage.setItem("selectedCity", verifyOtpResponse?.full_profile?.pref_locality_name);

  // }, [verifyOtpResponse])

  // const varifyOtp = (path: string) => {
  //     console.log(path);
  //     console.log(otp);
  //     const enterdOtp = otp.join("")

  //     if (otp.includes("")) {
  //         setError('Please enter all 4 digits of the OTP');
  //         return
  //     }
  //     // if (enterdOtp !== '0000') {
  //     //     setError("Wrong OTP entered");
  //     //     return
  //     // }
  //     setError('');
  //     navigate(path);
  // }

  // Starts component s
  // const varifyOtp = async () => {
  //   // console.log(otp);

  //   const enteredOtp = otp.join("");

  //   console.log(enteredOtp, "enteredOtp");

  //   if (otp.includes("")) {
  //     setError("Please enter all 4 digits of the OTP");
  //     return;
  //   }

  //   try {
  //     const res = await verifyOtpApi({
  //       phoneNumber: location.state?.phoneNumber,
  //       // otp: Number(location.state.otp),
  //       otp: Number(enteredOtp),
  //     });

  //     console.log(res, " i am response");

  //     if (res?.success) {
  //       console.log("OTP verified successfully:", res);

  //       // Optionally store data
  //       localStorage.setItem("accessToken", res.accessToken);
  //       localStorage.setItem("lead_profile_id", res.lead_profile_id);
  //       localStorage.setItem(
  //         "selectedCity",
  //         res.full_profile?.pref_city_name || ""
  //       );
  //       localStorage.setItem(
  //         "selectedCityId",
  //         res.full_profile?.pref_city_id || ""
  //       );

  //       // ✅ Set selected locality name (as array)
  //       const localityName = res.full_profile?.pref_locality_name || "";
  //       localStorage.setItem(
  //         "selectedLocality",
  //         JSON.stringify([localityName])
  //       );

  //       // ✅ Set selected locality full object (array of one object)
  //       const localityId = res.full_profile?.pref_locality_id || "";
  //       localStorage.setItem(
  //         "selectedLocalityFull",
  //         JSON.stringify([
  //           {
  //             locality_name: localityName,
  //             locality_id: Number(localityId),
  //           },
  //         ])
  //       );

  //       // ✅ Set selected locality IDs as comma-separated string (or store as array if needed)
  //       localStorage.setItem("SelectedLocalityId", localityId);

  //       // ✅ Get gender from API
  //       const genderAPI = res.full_profile?.gender || "";
  //       localStorage.setItem("genderAPI", genderAPI);

  //       // ✅ Map API gender to human-readable value
  //       let genderReadable = "";
  //       switch (genderAPI) {
  //         case "GENDER_MALE":
  //           genderReadable = "Male";
  //           break;
  //         case "GENDER_FEMALE":
  //           genderReadable = "Female";
  //           break;
  //         case "GENDER_OTHER":
  //           genderReadable = "Other";
  //           break;
  //         default:
  //           genderReadable = ""; // or "Prefer not to say"
  //       }

  //       localStorage.setItem("gender", genderReadable);

  //       // set min and max
  //       const minAmount = res.full_profile?.pref_budget_min_range || "";
  //       const maxAmount = res.full_profile?.pref_budget_max_range || "";

  //       localStorage.setItem("minAmount", minAmount.toString());
  //       localStorage.setItem("maxAmount", maxAmount.toString());

  //       // ✅ Call LOGIN service (do not block OTP flow if this fails)
  //       try {
  //         await callService("LOGIN", [
  //           {
  //             param: "MOBILE_NO",
  //             value: res.phoneNumber,
  //           },
  //         ]);
  //       } catch (loginError) {
  //         console.warn(
  //           "LOGIN service failed after OTP verification:",
  //           loginError
  //         );
  //         // Optional: Show toast or fallback
  //       }

  //       // ✅ Check for selected city in session
  //       // const selectedCity = localStorage.getItem("selectedCity");
  //       // const selectedLocalityId = localStorage.getItem("SelectedLocalityId");
  //       // const genderAPIcheck = localStorage.getItem("gender");
  //       // const minAmountcheck = localStorage.getItem("minAmount")
  //       // const maxAmountcheck = localStorage.getItem("maxAmount")

  //       // if (!selectedCity) {
  //       //     navigate("/onbording5");
  //       // }
  //       // if (selectedCity && !selectedLocalityId) {
  //       //     navigate("/onbording6");
  //       // } else if (!genderAPIcheck || !minAmountcheck || !maxAmountcheck) {
  //       //     console.log("gender, min, max  nahi hai");
  //       //     navigate("/onbording7");
  //       // } else if (selectedCity && selectedLocalityId && genderAPIcheck && minAmountcheck && maxAmountcheck) {
  //       //     console.log("filter  nahi hai");
  //       //     navigate("/search-result");
  //       // } else {
  //       //     console.warn("Unexpected state: some required fields are missing.");
  //       // }

  //       const selectedCity = localStorage.getItem("selectedCity")?.trim();
  //       const selectedLocalityId = sessionStorage
  //         .getItem("SelectedLocalityId")
  //         ?.trim();
  //       const genderAPIcheck = localStorage.getItem("gender")?.trim();
  //       const minAmountcheck = localStorage.getItem("minAmount")?.trim();
  //       const maxAmountcheck = localStorage.getItem("maxAmount")?.trim();

  //       if (!selectedCity) {
  //         navigate("/onbording5");
  //       } else if (!selectedLocalityId) {
  //         navigate("/onbording6");
  //       } else if (!genderAPIcheck || !minAmountcheck || !maxAmountcheck) {
  //         console.log("gender, min, max nahi hai");
  //         navigate("/onbording7");
  //       } else {
  //         console.log("filter hai");
  //         navigate("/search-result");
  //       }

  //       // if (selectedCity) {
  //       //     navigate("/onbording6", { state: res });
  //       // }
  //       // else {
  //       //     navigate(path, { state: res });
  //       // }
  //     } else {
  //       console.log(res, "OTP verification failed")
  //       setError(res?.message || "OTP verification failed");
  //     }
  //   } catch (error) {
  //     console.error("Error verifying OTP:", error);
  //     setError("Something went wrong. Please try again.");
  //   }
  // };

  useEffect(() => {
    console.log(location.state?.from, "location.state?.from................");
  }, []);

  useEffect(() => {
    document.cookie = `myVar=${encodeURIComponent("12345")}; max-age=${
      60 * 60
    }; path=/`;
  }, []);

  function readClientCookie(name: any) {
    const match = document.cookie.match(
      new RegExp("(^|; )" + name + "=([^;]*)"),
    );
    const res = match ? decodeURIComponent(match[2]) : null;
    console.log(res);
    return res;
  }

  const varifyOtp = async () => {
    // console.log(otp);
    const enteredOtp = otp.join("");
    console.log(enteredOtp, "enteredOtp");
    if (otp.includes("")) {
      setError("Please enter all 4 digits of the OTP");
      return;
    }
    setVarifyOtpLoading(true);
    try {
      const response = await axios.post<VerifyOtpResponse>(
        // "https://nestfin.app:8443/api/leads/v1/verify-otp",
        // `${apibaseurl}/api/leads/v1/verify-otp`,
        `${apibaseurl}${verifyOtp}`,
        {
          phoneNumber: location.state?.phoneNumber,
          // otp: Number(location.state.otp),
          otp: Number(enteredOtp),
        },
      );

      // const res = await verifyOtpApi({
      //   phoneNumber: location.state?.phoneNumber,
      //   // otp: Number(location.state.otp),
      //   otp: Number(enteredOtp),
      // });

      const res = response.data;

      if (res?.success) {
        // console.log("OTP verified successfully:", res);

        // Optionally store data
        localStorage.setItem("accessToken", res.accessToken);
        localStorage.setItem("lead_profile_id", res.lead_profile_id);

        const newCity = res.full_profile?.pref_city_name;
        const newCityId = res.full_profile?.pref_city_id;
        const existingCity = localStorage.getItem("selectedCity") || "";
        const existingCityId = localStorage.getItem("selectedCityId") || "";

        // ✅ If API gives valid city name, use it; otherwise keep existing
        localStorage.setItem(
          "selectedCity",
          newCity && newCity.trim() !== "" ? newCity : existingCity,
        );

        localStorage.setItem(
          "selectedCityId",
          newCityId && newCityId.toString().trim() !== ""
            ? newCityId
            : existingCityId,
        );
        // ✅ Set selected locality name (as array)
        // const localityName = res.full_profile?.pref_locality_name || "";
        // localStorage.setItem(
        //   "selectedLocality",
        //   JSON.stringify([localityName])
        // );

        // ✅ Set selected locality full object (array of one object)
        const localityId = res.full_profile?.pref_locality_id || "";
        localStorage.setItem(
          "selectedLocalityFull",
          JSON.stringify([
            {
              // locality_name: localityName,
              locality_id: Number(localityId),
            },
          ]),
        );
        // ✅ Set selected locality IDs as comma-separated string (or store as array if needed)
        localStorage.setItem("SelectedLocalityId", localityId);

        // ✅ Get gender from API
        const genderAPI = res.full_profile?.gender || "";
        localStorage.setItem("genderAPI", genderAPI);

        // ✅ Map API gender to human-readable value
        let genderReadable = "";
        switch (genderAPI) {
          case "GENDER_MALE":
            genderReadable = "Male";
            break;
          case "GENDER_FEMALE":
            genderReadable = "Female";
            break;
          case "GENDER_OTHER":
            genderReadable = "Other";
            break;
          default:
            genderReadable = ""; // or "Prefer not to say"
        }

        localStorage.setItem("gender", genderReadable);

        // set min and max
        const minAmount = res.full_profile?.pref_budget_min_range || "";
        const maxAmount = res.full_profile?.pref_budget_max_range || "20000";

        localStorage.setItem("minAmount", minAmount.toString());
        localStorage.setItem("maxAmount", maxAmount.toString());

        // ✅ Call LOGIN service (do not block OTP flow if this fails)
        try {
          await callService("LOGIN", [
            {
              param: "MOBILE_NO",
              value: res.phoneNumber,
            },
          ]);
        } catch (loginError) {
          console.warn(
            "LOGIN service failed after OTP verification:",
            loginError,
          );
          // Optional: Show toast or fallback
        }
        // check Previous route------------------
        // Check first if ProtectedRoute sent a 'from' route
        let redirectTo = location.state?.from;

        // If not, check if a post-login redirect exists in localStorage (like for /loan-options)
        if (!redirectTo) {
          redirectTo = localStorage.getItem("postLoginRedirect");
          if (redirectTo) {
            localStorage.removeItem("postLoginRedirect"); // clean up
          }
        }

        // Perform redirect if we have a target
        if (redirectTo) {
          console.log("Redirecting user back to:", redirectTo);
          navigate(redirectTo, { replace: true });
          return; // Exit early to prevent onboarding logic
        }

        // ✅ Check for selected city in session
        // const selectedCity = localStorage.getItem("selectedCity");
        // const selectedLocalityId = localStorage.getItem("SelectedLocalityId");
        // const genderAPIcheck = localStorage.getItem("gender");
        // const minAmountcheck = localStorage.getItem("minAmount")
        // const maxAmountcheck = localStorage.getItem("maxAmount")

        // if (!selectedCity) {
        //     navigate("/onbording5");
        // }
        // if (selectedCity && !selectedLocalityId) {
        //     navigate("/onbording6");
        // } else if (!genderAPIcheck || !minAmountcheck || !maxAmountcheck) {
        //     console.log("gender, min, max  nahi hai");
        //     navigate("/onbording7");
        // } else if (selectedCity && selectedLocalityId && genderAPIcheck && minAmountcheck && maxAmountcheck) {
        //     console.log("filter  nahi hai");
        //     navigate("/search-result");
        // } else {
        //     console.warn("Unexpected state: some required fields are missing.");
        // }

        // 🔹 show modal
        // setConfirmModal(true);

        // 🔹 Auto-close after 1 second
        setTimeout(() => {
          setConfirmModal(false);

          // Check session data again before navigating
          const selectedCity = localStorage.getItem("selectedCity")?.trim();
          const selectedLocalityId = sessionStorage
            .getItem("SelectedLocalityId")
            ?.trim();
          const genderAPIcheck = localStorage.getItem("gender")?.trim();
          const minAmountcheck = localStorage.getItem("minAmount")?.trim();
          const maxAmountcheck = localStorage.getItem("maxAmount")?.trim();

          if (!selectedCity) {
            navigate("/home", { replace: true });
            navigate("/onbording5");
          } else if (!selectedLocalityId) {
            navigate("/home", { replace: true });
            navigate("/onbording6");
          } else if (!genderAPIcheck || !minAmountcheck || !maxAmountcheck) {
            navigate("/home", { replace: true });
            navigate("/onbording7");
          } else {
            navigate("/home", { replace: true });
            navigate("/search-result");
          }
        }, 1000);

        // const selectedCity = localStorage.getItem("selectedCity")?.trim();
        // const selectedLocalityId = sessionStorage
        //   .getItem("SelectedLocalityId")
        //   ?.trim();
        // const genderAPIcheck = localStorage.getItem("gender")?.trim();
        // const minAmountcheck = localStorage.getItem("minAmount")?.trim();
        // const maxAmountcheck = localStorage.getItem("maxAmount")?.trim();

        // if (!selectedCity) {
        //   navigate("/onbording5");
        // } else if (!selectedLocalityId) {
        //   navigate("/onbording6");
        // } else if (!genderAPIcheck || !minAmountcheck || !maxAmountcheck) {
        //   // console.log("gender, min, max nahi hai");
        //   navigate("/onbording7");
        // } else {
        //   // console.log("filter hai");
        //   navigate("/search-result");
        // }

        // if (selectedCity) {
        //     navigate("/onbording6", { state: res });
        // }
        // else {
        //     navigate(path, { state: res });
        // }
      } else {
        console.log(res, "OTP verification failed");
        setError(res?.message || "OTP verification failed");
      }
    } catch (err: unknown) {
      // ✅ narrow error type
      const axiosError = err as AxiosError<ApiErrorResponse>;

      if (axiosError.response?.data) {
        const errorData = axiosError.response.data;
        console.error("API Error:", errorData.message); // "Invalid or expired OTP"
        setError(errorData.message);
      } else {
        console.error("Unexpected Error:", err);
        setError("Something went wrong. Please try again.");
      }
    } finally {
      setVarifyOtpLoading(false);
    }
  };

  // **************** START Component Here *************

  const renderTitle = (): JSX.Element => {
    return (
      <div className="container">
        <p className="heading"> Enter Your Verification Code</p>
      </div>
    );
  };

  const renderDescription = (): JSX.Element => {
    const maskPhoneNumber = (phone?: string): string => {
      if (!phone) return "";
      const visibleDigits = phone.slice(-4); // last 2 digits
      return `*******${visibleDigits}`;
    };
    const maskedNumber = maskPhoneNumber(location.state?.phoneNumber);
    return (
      <div className="container">
        <text.T16
          style={{
            lineHeight: 1,
            textAlign: "center",
            whiteSpace: "pre-line",
          }}
        >
          We’ve sent a code to +91 {maskedNumber}
          {/* {location?.state?.otp && (
            <h1 style={{ marginTop: "10px" }}>
              Your OTP is : {location?.state?.otp}
            </h1>
          )} */}
        </text.T16>
      </div>
    );
  };
  const renderDescription2 = (): JSX.Element => {
    return (
      <div className="container">
        <text.T16
          style={{
            lineHeight: 1,
            whiteSpace: "pre-line",
            color: "#0000ff",
            cursor: "pointer",
          }}
          onClick={() =>
            navigate("/onbording3", {
              state: { phoneNumber: location.state.phoneNumber },
            })
          }
        >
          Resend the OTP
        </text.T16>
      </div>
    );
  };
  const renderDescription1 = (): JSX.Element => {
    return (
      <div className="container">
        <div className="otpInputContainer" style={{ marginTop: 20 }}>
          {otp?.map((digit, index) => (
            <input
              key={index}
              type="tel"
              maxLength={1}
              value={digit ?? ""}
              onChange={(e) => {
                handleChange(e.target.value, index);
                if (error) setError("");
              }}
              onKeyDown={(e) => handleKeyDown(e, index)}
              ref={(el) => (inputRefs.current[index] = el!)}
              className="otpInputBox"
            />
          ))}
        </div>

        {error && (
          <div style={{ color: "red", marginTop: "12px" }}>{error}</div>
        )}
      </div>
    );
  };

  const renderButtons = (): JSX.Element => (
    <div
      style={{
        position: "absolute",
        bottom: 0,
        width: "100%",
        padding: "36px 16px 36px 16px",
        background: " #ffffffa1",
        backdropFilter: "blur(4px)",
        boxSizing: "border-box",
        borderTopLeftRadius: 16,
        borderTopRightRadius: 16,
      }}
    >
      <div
        className="button-container"
        style={{ display: "flex", flexDirection: "column", gap: 16 }}
      >
        {renderTitle()}

        {renderDescription()}
        {renderDescription1()}
        {renderDescription2()}
        {/* <div
          id="onbording3"
          className="active-button"
          onClick={() => varifyOtp()}
        >
          <span>Verify</span>
        </div> */}

        <div
          id="onbording3"
          className="active-button"
          onClick={() => !varifyOtpLoading && varifyOtp()} // prevent double click
          // onClick={readClientCookie}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: varifyOtpLoading ? "not-allowed" : "pointer",
            opacity: varifyOtpLoading ? 0.7 : 1,
          }}
        >
          {varifyOtpLoading ? (
            <div className="loaderButton"></div>
          ) : (
            <span>Verify</span>
          )}
        </div>
      </div>
    </div>
  );
  return (
    <div style={{ position: "relative", height: "100dvh", overflow: "hidden" }}>
      <div
        style={{
          width: "100%",
          height: "100%",
          overflow: "hidden",
          position: "relative",
        }}
      >
        <img
          src={require("../assets/nestfin/mainb1.jpg")}
          alt="Onboarding Visual"
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
        />
        {renderButtons()}

        {/* when successfully login show this */}
        {/* when successfully login show this */}
        {confirmModal && (
          <div className="modal-overlay">
            <div className="modal-content">
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  padding: "30px",
                }}
              >
                <img
                  alt="Success"
                  // src={require("../assets/other/checked.png")}
                  src="https://img.freepik.com/free-vector/sign-page-abstract-concept-illustration-enter-application-mobile-screen-user-login-form-website-page-interface-ui-new-profile-registration-email-account_335657-936.jpg?t=st=1758114840~exp=1758118440~hmac=bd5cb17849614842557e6557a52ee25a6a49bcb60e9b4f10d5504ce9f2ce6119&w=1060"
                  style={{ width: "50%", height: "auto", margin: "0px 0" }}
                />

                <p
                  style={{
                    textAlign: "center",
                    marginBottom: 10,
                    // lineHeight: "1.6",
                    fontSize: "26px",
                    fontWeight: "bold",
                    color: "var(--primary-color)",
                  }}
                >
                  Login Successful!
                </p>
                {/* <p
          style={{
            whiteSpace: "pre-line",
            textAlign: "center",
            margin: "10px 0",
            fontSize: "16px",
          }}
        >
          Redirecting you in 1 second...
        </p> */}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

// ------------- verify otp function before cleanup -----------------------
// const varifyOtp = async () => {
//   // console.log(otp);
//   const enteredOtp = otp.join("");
//   console.log(enteredOtp, "enteredOtp");
//   if (otp.includes("")) {
//     setError("Please enter all 4 digits of the OTP");
//     return;
//   }
//   setVarifyOtpLoading(true);
//   try {
//     const response = await axios.post<VerifyOtpResponse>(
//       // "https://nestfin.app:8443/api/leads/v1/verify-otp",
//       // `${apibaseurl}/api/leads/v1/verify-otp`,
//       `${apibaseurl}${verifyOtp}`,
//       {
//         phoneNumber: location.state?.phoneNumber,
//         // otp: Number(location.state.otp),
//         otp: Number(enteredOtp),
//       }
//     );

//     // const res = await verifyOtpApi({
//     //   phoneNumber: location.state?.phoneNumber,
//     //   // otp: Number(location.state.otp),
//     //   otp: Number(enteredOtp),
//     // });

//     const res = response.data;

//     if (res?.success) {
//       console.log("OTP verified successfully:", res);

//       // Optionally store data
//       localStorage.setItem("accessToken", res.accessToken);
//       localStorage.setItem("lead_profile_id", res.lead_profile_id);

//       const newCity = res.full_profile?.pref_city_name;
//       const newCityId = res.full_profile?.pref_city_id;
//       const existingCity = localStorage.getItem("selectedCity") || "";
//       const existingCityId = localStorage.getItem("selectedCityId") || "";

//       // ✅ If API gives valid city name, use it; otherwise keep existing
//       localStorage.setItem(
//         "selectedCity",
//         newCity && newCity.trim() !== "" ? newCity : existingCity
//       );

//       localStorage.setItem(
//         "selectedCityId",
//         newCityId && newCityId.toString().trim() !== ""
//           ? newCityId
//           : existingCityId
//       );
//       // ✅ Set selected locality name (as array)
//       // const localityName = res.full_profile?.pref_locality_name || "";
//       // localStorage.setItem(
//       //   "selectedLocality",
//       //   JSON.stringify([localityName])
//       // );

//       // ✅ Set selected locality full object (array of one object)
//       const localityId = res.full_profile?.pref_locality_id || "";
//       localStorage.setItem(
//         "selectedLocalityFull",
//         JSON.stringify([
//           {
//             // locality_name: localityName,
//             locality_id: Number(localityId),
//           },
//         ])
//       );
//       // ✅ Set selected locality IDs as comma-separated string (or store as array if needed)
//       localStorage.setItem("SelectedLocalityId", localityId);

//       // ✅ Get gender from API
//       const genderAPI = res.full_profile?.gender || "";
//       localStorage.setItem("genderAPI", genderAPI);

//       // ✅ Map API gender to human-readable value
//       let genderReadable = "";
//       switch (genderAPI) {
//         case "GENDER_MALE":
//           genderReadable = "Male";
//           break;
//         case "GENDER_FEMALE":
//           genderReadable = "Female";
//           break;
//         case "GENDER_OTHER":
//           genderReadable = "Other";
//           break;
//         default:
//           genderReadable = ""; // or "Prefer not to say"
//       }

//       localStorage.setItem("gender", genderReadable);

//       // set min and max
//       const minAmount = res.full_profile?.pref_budget_min_range || "";
//       const maxAmount = res.full_profile?.pref_budget_max_range || "";

//       localStorage.setItem("minAmount", minAmount.toString());
//       localStorage.setItem("maxAmount", maxAmount.toString());

//       // ✅ Call LOGIN service (do not block OTP flow if this fails)
//       try {
//         await callService("LOGIN", [
//           {
//             param: "MOBILE_NO",
//             value: res.phoneNumber,
//           },
//         ]);
//       } catch (loginError) {
//         console.warn(
//           "LOGIN service failed after OTP verification:",
//           loginError
//         );
//         // Optional: Show toast or fallback
//       }

//       // check Previous route---------------------------------************************

//       // Check first if ProtectedRoute sent a 'from' route
//       let redirectTo = location.state?.from;

//       // If not, check if a post-login redirect exists in localStorage (like for /loan-options)
//       if (!redirectTo) {
//         redirectTo = localStorage.getItem("postLoginRedirect");
//         if (redirectTo) {
//           localStorage.removeItem("postLoginRedirect"); // clean up
//         }
//       }

//       // Perform redirect if we have a target
//       if (redirectTo) {
//         console.log("Redirecting user back to:", redirectTo);
//         navigate(redirectTo, { replace: true });
//         return; // Exit early to prevent onboarding logic
//       }

//       // ✅ Check for selected city in session
//       // const selectedCity = localStorage.getItem("selectedCity");
//       // const selectedLocalityId = localStorage.getItem("SelectedLocalityId");
//       // const genderAPIcheck = localStorage.getItem("gender");
//       // const minAmountcheck = localStorage.getItem("minAmount")
//       // const maxAmountcheck = localStorage.getItem("maxAmount")

//       // if (!selectedCity) {
//       //     navigate("/onbording5");
//       // }
//       // if (selectedCity && !selectedLocalityId) {
//       //     navigate("/onbording6");
//       // } else if (!genderAPIcheck || !minAmountcheck || !maxAmountcheck) {
//       //     console.log("gender, min, max  nahi hai");
//       //     navigate("/onbording7");
//       // } else if (selectedCity && selectedLocalityId && genderAPIcheck && minAmountcheck && maxAmountcheck) {
//       //     console.log("filter  nahi hai");
//       //     navigate("/search-result");
//       // } else {
//       //     console.warn("Unexpected state: some required fields are missing.");
//       // }

//       // 🔹 show modal
//       // setConfirmModal(true);

//       // 🔹 Auto-close after 1 second
//       setTimeout(() => {
//         setConfirmModal(false);

//         // Check session data again before navigating
//         const selectedCity = localStorage.getItem("selectedCity")?.trim();
//         const selectedLocalityId = sessionStorage
//           .getItem("SelectedLocalityId")
//           ?.trim();
//         const genderAPIcheck = localStorage.getItem("gender")?.trim();
//         const minAmountcheck = localStorage.getItem("minAmount")?.trim();
//         const maxAmountcheck = localStorage.getItem("maxAmount")?.trim();

//         if (!selectedCity) {
//           navigate("/home", { replace: true });
//           navigate("/onbording5");
//         } else if (!selectedLocalityId) {
//           navigate("/home", { replace: true });
//           navigate("/onbording6");
//         } else if (!genderAPIcheck || !minAmountcheck || !maxAmountcheck) {
//           navigate("/home", { replace: true });
//           navigate("/onbording7");
//         } else {
//           navigate("/home", { replace: true });
//           navigate("/search-result");
//         }
//       }, 1000);

//       // const selectedCity = localStorage.getItem("selectedCity")?.trim();
//       // const selectedLocalityId = sessionStorage
//       //   .getItem("SelectedLocalityId")
//       //   ?.trim();
//       // const genderAPIcheck = localStorage.getItem("gender")?.trim();
//       // const minAmountcheck = localStorage.getItem("minAmount")?.trim();
//       // const maxAmountcheck = localStorage.getItem("maxAmount")?.trim();

//       // if (!selectedCity) {
//       //   navigate("/onbording5");
//       // } else if (!selectedLocalityId) {
//       //   navigate("/onbording6");
//       // } else if (!genderAPIcheck || !minAmountcheck || !maxAmountcheck) {
//       //   // console.log("gender, min, max nahi hai");
//       //   navigate("/onbording7");
//       // } else {
//       //   // console.log("filter hai");
//       //   navigate("/search-result");
//       // }

//       // if (selectedCity) {
//       //     navigate("/onbording6", { state: res });
//       // }
//       // else {
//       //     navigate(path, { state: res });
//       // }
//     } else {
//       console.log(res, "OTP verification failed");
//       setError(res?.message || "OTP verification failed");
//     }
//   } catch (err: unknown) {
//     // ✅ narrow error type
//     const axiosError = err as AxiosError<ApiErrorResponse>;

//     if (axiosError.response?.data) {
//       const errorData = axiosError.response.data;
//       console.error("API Error:", errorData.message); // "Invalid or expired OTP"
//       setError(errorData.message);
//     } else {
//       console.error("Unexpected Error:", err);
//       setError("Something went wrong. Please try again.");
//     }
//   } finally {
//     setVarifyOtpLoading(false);
//   }
// };

// -------------------------------------------------

// ****************************************
// import { useLocation } from 'react-router-dom';
// import React, { useEffect, useRef, useState } from 'react';
// import useEmblaCarousel from 'embla-carousel-react';

// import { text } from '../text';
// import { hooks } from '../hooks';
// import { utils } from '../utils';
// import { theme } from '../constants';
// import { components } from '../components';
// import useApi from '../customHook/useApi';

// export interface VerifyOtpResponse {
//     success: boolean;
//     statusCode: number;
//     phoneNumber: string;
//     accessToken: string;
//     lead_profile_id: string;
//     message: string;
// }

// export const Onboarding4: React.FC = () => {
//     const location = useLocation();
//     // const { phonOtp } = location.state || {};
//     const { pathname } = useLocation();
//     const navigate = hooks.useNavigate();
//     const [otp, setOtp] = useState(['', '', '', '']);
//     const [expectedOtp, setExpectedOtp] = useState(""); // Store the OTP from state
//     const inputRefs = useRef<HTMLInputElement[]>([]);
//     const [error, setError] = useState("")

//     useEffect(() => {
//         console.log(location.state.otp, location.state.phoneNumber, "from navigation");
//     }, []);

//     const handleChange = (value: string, index: number) => {
//         if (!/^\d*$/.test(value)) return; // allow only numbers

//         const newOtp = [...otp];
//         newOtp[index] = value;
//         setOtp(newOtp);

//         if (value && index < 3) {
//             inputRefs.current[index + 1]?.focus();
//         }
//     };

//     const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>, index: number) => {
//         if (e.key === 'Backspace' && !otp[index] && index > 0) {
//             inputRefs.current[index - 1]?.focus();
//         }
//     };

//     const buttons = [
//         {
//             title: 'Verify',
//             path: '/onbording5',
//         }
//     ];

//     const {
//         data: verifyOtpResponse,
//         loading: verifyLoading,
//         callApi: verifyOtpApi,
//     } = useApi<VerifyOtpResponse>("/api/v1/verify-otp", {
//         method: "POST",
//         autoCall: false,
//         dependencies: [],
//     });

//     // const varifyOtp = (path: string) => {
//     //     console.log(path);
//     //     console.log(otp);
//     //     const enterdOtp = otp.join("")

//     //     if (otp.includes("")) {
//     //         setError('Please enter all 4 digits of the OTP');
//     //         return
//     //     }
//     //     // if (enterdOtp !== '0000') {
//     //     //     setError("Wrong OTP entered");
//     //     //     return
//     //     // }
//     //     setError('');
//     //     navigate(path);
//     // }

//     // Starts component s
//     const varifyOtp = async (path: string) => {
//         // console.log(otp);

//         const enteredOtp = otp.join("");

//         console.log(enteredOtp, "enteredOtp");

//         if (otp.includes("")) {
//             setError("Please enter all 4 digits of the OTP");
//             return;
//         }

//         try {
//             const res = await verifyOtpApi({
//                 body: {
//                     phoneNumber: location.state?.phoneNumber,  // <-- REQUIRED
//                     otp: Number(enteredOtp),                   // <-- USER INPUT
//                 },
//             });

//             console.log(res, " i am response");

//             if (res?.success) {
//                 console.log("OTP verified successfully:", res);

//                 // Optionally store data
//                 localStorage.setItem("accessToken", res.accessToken);
//                 localStorage.setItem("lead_profile_id", res.lead_profile_id);

//                 navigate(path, { state: res }); // pass verified data to next page
//             } else {
//                 setError(res?.message || "OTP verification failed");
//             }
//         } catch (error) {
//             console.error("Error verifying OTP:", error);
//             setError("Something went wrong. Please try again.");
//         }
//     };
